export const CREATE_BOOKING_REFETCH_DELAY = 8000 // in ms
